import React, {ChangeEvent, FC, useCallback} from 'react';
import {useField} from 'formik';
import MaterialCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

interface CheckboxProps {
  checked?: boolean,
  label?: string,
  onChange?: (value: boolean) => void,
  size?: 'small' | 'medium',
  name: string,
  id?: string,
  disabled?: boolean,
  required?: boolean,
  onBlur?: () => void,
  onFocus?: () => void
}

const Checkbox: FC<CheckboxProps> = ({
  name,
  label,
  onChange,
  onBlur,
  onFocus,
  disabled,
  required,
  checked,
  size
}) => {
  const [
    {value, onChange: formikOnChange},
    ,
    {setTouched}
  ] = useField(name);

  const handleChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
          return onChange(event.target.checked);
        }

        setTouched(true);
        formikOnChange(event);
      }, []);

  return (
    <FormControlLabel
      control={(
        <MaterialCheckbox
          required={required}
          name={name}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          value={checked || value}
          checked={checked || value}
          size={size}
        />
      )}
      label={label || ''}
    />
  );
};

export default Checkbox;
